import Box from '@mui/material/Box';

const SplitBackground = () => (
	<Box
		sx={{
			width: '100%',
			height: '100vh',
			position: 'fixed',
			left: 0,
			top: 0,
			clipPath: 'polygon(0 0, 59% 0, 47% 100%, 0 100%)',
			backgroundImage: 'linear-gradient(128deg, #c21b17 0%, #8e1230 50%)',
			zIndex: 0,
		}}
	/>
);

export default SplitBackground;
